define('NMSDesignSystem.StartupData.Shopping', ['jQuery', 'Profile.Model'], function(jQuery, ProfileModel) {
    'use strict';

    // Run from the Shopping head; hand the same current-document response to
    // native loadJSON later. No persistent storage, shared cache or inferred user.
    function installEarlyUserEnvironment(win, rawUrl) {
        if (win.nmsEarlyUserEnvironment || !win.XMLHttpRequest || !win.URL) return;
        var url;
        try {
            url = new win.URL(rawUrl, win.location.href);
            if (url.origin !== win.location.origin || url.hash ||
                    !/^\/sca-dev-2026-1-0\/services\/ShoppingUserEnvironment\.Service\.ss$/.test(url.pathname)) return;
        } catch (error) { return; }
        var state = 'pending', used = false, data = null, resolveNative, retryNative;
        var stats = {started: 0, reused: 0, failed: 0};
        function complete(ok, xhr) {
            if (state !== 'pending') return;
            try {
                if (!ok || xhr.status !== 200) throw new Error('Native fallback required');
                data = JSON.parse(xhr.responseText);
                if (!data || typeof data !== 'object' || Array.isArray(data) || data.error || data.errorCode) throw new Error('Native fallback required');
                state = 'ready';
            } catch (error) { state = 'failed'; data = null; stats.failed += 1; }
            if (used) {
                var success = resolveNative, fallback = retryNative, value = data;
                resolveNative = retryNative = data = null;
                if (state === 'ready') success(value); else fallback();
            }
        }
        win.nmsEarlyUserEnvironment = {
            take: function(raw, success, fallback) {
                var requested;
                try { requested = new win.URL(raw, win.location.href).href; } catch (error) { return false; }
                if (used || state === 'failed' || requested !== url.href || typeof success !== 'function' || typeof fallback !== 'function') return false;
                used = true; stats.reused += 1;
                if (state === 'ready') { var value = data; data = null; success(value); }
                else { resolveNative = success; retryNative = fallback; }
                return true;
            },
            getStatistics: function() { return {started: stats.started, reused: stats.reused, failed: stats.failed}; }
        };
        try {
            var xhr = new win.XMLHttpRequest();
            xhr.open('GET', url.href);
            xhr.onreadystatechange = function() { if (xhr.readyState === 4) complete(true, xhr); };
            xhr.onerror = xhr.onabort = function() { complete(false, xhr); };
            stats.started += 1; xhr.send(null);
            // A redirected or replaced native page must not retain an unused
            // private response indefinitely. A claimed request stays native-owned.
            win.setTimeout(function() { if (!used) { state = 'failed'; data = null; xhr.abort(); } }, 30000);
        } catch (error) { complete(false, {status: 0}); }
    }

    // Serialized into shopping.ssp before the large native bundle. It keeps one
    // short-lived, anonymous, same-origin item response in this document only.
    function installEarlyCatalogData(win, doc, page) {
        if (win.nmsInitialItemData || !win.SC || !win.SC.ENVIRONMENT ||
                win.SC.ENVIRONMENT.jsEnvironment !== 'browser' ||
                !win.SC.isPageGenerator || win.SC.isPageGenerator()) return;
        var hosts = ['nmsincusa.com', 'buyflushots.nmsincusa.com',
            'sca-sandbox.ethanablatt.com', 'buyflu-sandbox.ethanablatt.com'];
        if (hosts.indexOf(win.location.hostname) < 0 || !win.XMLHttpRequest || !win.URL) return;
        var environment = win.loadedResourcesPromises && win.loadedResourcesPromises.shoppingUserEnvironment;
        if (!environment || typeof environment.done !== 'function') return;
        var entry = null, stats = {started: 0, reused: 0, failed: 0, expired: 0};
        var headers = {'Accept': 'application/json, text/javascript, */*; q=0.01',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest', 'X-SC-Touchpoint': 'shopping'};
        function route() {
            return (win.location.hash && win.location.hash.replace(/^#\/?/, '/') ||
                win.location.pathname).split('?')[0].replace(/\/$/, '') || '/';
        }
        function key(raw) {
            try {
                var url = new win.URL(raw, win.location.href), pairs = [], names = [];
                if (url.origin !== win.location.origin || url.pathname !== '/api/cacheable/items' || url.hash) return null;
                url.searchParams.forEach(function(value, name) {
                    if (names.indexOf(name) >= 0) throw new Error('Ambiguous query');
                    names.push(name); pairs.push([name, value]);
                });
                pairs.sort(function(a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0; });
                return url.origin + url.pathname + '?' + pairs.map(function(pair) {
                    return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]);
                }).join('&');
            } catch (error) { return null; }
        }
        function finish(ok, xhr) {
            if (!entry || entry.state !== 'pending') return;
            var text = '', data;
            try {
                text = xhr.responseText;
                if (!ok || xhr.status !== 200 || text.length > 500000 ||
                        !/application\/json/i.test(xhr.getResponseHeader('Content-Type') || '')) throw new Error('Unusable response');
                data = JSON.parse(text);
                if (!data || !Array.isArray(data.items) || data.error || data.errorCode) throw new Error('Not item data');
                entry.text = text; entry.headers = xhr.getAllResponseHeaders(); entry.statusText = xhr.statusText;
                entry.finished = Date.now(); entry.state = 'ready';
                win.setTimeout(function() {
                    if (entry && entry.state === 'ready') {
                        entry.text = ''; entry.state = 'failed'; stats.expired += 1;
                    }
                }, 10000);
            } catch (error) { entry.state = 'failed'; stats.failed += 1; }
            var callbacks = entry.callbacks; entry.callbacks = [];
            callbacks.forEach(function(callback) { callback(entry.state === 'ready' ? entry : null); });
        }
        var availabilityEntry = null, availabilityStats = {started: 0, reused: 0, failed: 0, expired: 0};
        function finishAvailability(ok, xhr) {
            if (!availabilityEntry || availabilityEntry.state !== 'pending') return;
            try {
                if (!ok || xhr.status !== 200 || xhr.responseText.length > 500000 ||
                        !/application\/json/i.test(xhr.getResponseHeader('Content-Type') || '')) throw new Error('Native availability fallback required');
                var response = JSON.parse(xhr.responseText), item = response && response.items && response.items[0];
                if (response.error || response.errorCode || !Array.isArray(response.items) || response.items.length !== 1 ||
                        !item || !/^[1-9][0-9]*$/.test(String(item.internalid)) ||
                        item.custitem_availability != null && typeof item.custitem_availability !== 'string') throw new Error('Invalid availability data');
                availabilityEntry.value = {id: String(item.internalid), availability: item.custitem_availability || ''};
                availabilityEntry.finished = Date.now(); availabilityEntry.state = 'ready';
                win.setTimeout(function() {
                    if (availabilityEntry && !availabilityEntry.used && availabilityEntry.state === 'ready') {
                        availabilityEntry.value = null; availabilityEntry.state = 'failed'; availabilityStats.expired += 1;
                    }
                }, 10000);
            } catch (error) { availabilityEntry.state = 'failed'; availabilityStats.failed += 1; }

        }
        function startAvailability(raw, current) {
            if (['buyflushots.nmsincusa.com', 'buyflu-sandbox.ethanablatt.com'].indexOf(win.location.hostname) < 0) return;
            var url = new win.URL(raw, win.location.href);
            if (url.searchParams.get('fieldset') !== 'details') return;
            // Request only the two public status fields. Preserve the native
            // account, site, currency, price level and personalized-catalog scope.
            url.searchParams.delete('fieldset'); url.searchParams.delete('include');
            url.searchParams.set('fields', 'internalid,custitem_availability');
            availabilityEntry = {route: current, state: 'pending', used: false, value: null};
            try {
                var xhr = new win.XMLHttpRequest(); xhr.open('GET', url.href, true); xhr.timeout = 8000;
                Object.keys(headers).forEach(function(name) { xhr.setRequestHeader(name, headers[name]); });
                xhr.onload = function() { finishAvailability(true, xhr); };
                xhr.onerror = xhr.ontimeout = xhr.onabort = function() { finishAvailability(false, xhr); };
                availabilityStats.started += 1; xhr.send();
            } catch (error) { finishAvailability(false, {status: 0}); }
        }
        win.nmsInitialItemData = {
            takeAvailability: function(expectedRoute, callback) {
                // Never delay native startup behind a slow speculative status request.
                if (!availabilityEntry || availabilityEntry.used || availabilityEntry.state !== 'ready' ||
                        expectedRoute !== availabilityEntry.route || route() !== expectedRoute) return false;
                if (availabilityEntry.state === 'ready' && Date.now() - availabilityEntry.finished > 10000) {
                    availabilityEntry.value = null; availabilityEntry.state = 'failed'; availabilityStats.expired += 1; return false;
                }
                availabilityEntry.used = true; availabilityStats.reused += 1;
                var value = availabilityEntry.value; availabilityEntry.value = null; callback(value);
                return true;
            },
            getAvailabilityStatistics: function() { return {started: availabilityStats.started, reused: availabilityStats.reused, failed: availabilityStats.failed, expired: availabilityStats.expired}; },
            expectedHeaders: headers,
            key: key,
            canTake: function(raw) {
                return !!(entry && !entry.used && entry.state !== 'failed' &&
                    key(raw) === entry.key && route() === entry.route &&
                    (entry.state !== 'ready' || Date.now() - entry.finished <= 10000));
            },
            take: function(raw, callback) {
                if (!entry || entry.used || key(raw) !== entry.key || route() !== entry.route || entry.state === 'failed') return false;
                if (entry.state === 'ready' && Date.now() - entry.finished > 10000) {
                    entry.text = ''; entry.state = 'failed'; stats.expired += 1; return false;
                }
                entry.used = true; stats.reused += 1;
                if (entry.state === 'ready') callback(entry);
                else entry.callbacks.push(callback);
                return true;
            },
            getStatistics: function() { return {started: stats.started, reused: stats.reused, failed: stats.failed, expired: stats.expired}; }
        };
        function startRequest(candidate, current) {
            entry = {key: candidate.key, route: current, state: 'pending', callbacks: [], used: false};
            try {
                var xhr = new win.XMLHttpRequest();
                xhr.open('GET', candidate.url, true); xhr.timeout = 8000;
                Object.keys(headers).forEach(function(name) { xhr.setRequestHeader(name, headers[name]); });
                xhr.onload = function() { finish(true, xhr); };
                xhr.onerror = xhr.ontimeout = xhr.onabort = function() { finish(false, xhr); };
                stats.started += 1; xhr.send();
            } catch (error) { finish(false, {responseText: '', status: 0}); }
            startAvailability(candidate.url, current);
        }
        function initialCatalogRequest(current) {
            // Human frame responses do not contain the renderer's hidden IMG.
            // Limit this speculation to the first catalog page or a server-qualified product, with
            // the independently verified native public configuration. The native
            // transport still requires exact query/header/current-profile equality.
            var details = page && page.family === 'pdp' && page.path === current &&
                /^\/[A-Za-z0-9][A-Za-z0-9._-]*$/.test(current) && /[A-Za-z]/.test(current);
            if (current !== '/products' && !details || win.location.search || win.location.hash ||
                    win.location.pathname !== current) return null;
            if (Array.prototype.some.call(doc.body.children, function(image) {
                if (image.tagName !== 'IMG' || image.style.display !== 'none') return false;
                try {
                    var nativeUrl = new win.URL(image.src, win.location.href);
                    return nativeUrl.origin === win.location.origin && nativeUrl.pathname === '/api/cacheable/items';
                } catch (error) { return false; }
            })) return null;
            var env = win.SC.ENVIRONMENT, config = win.SC.CONFIGURATION;
            var sandbox = win.location.hostname.indexOf('-sandbox.') >= 0;
            var account = sandbox ? '5216893_SB1' : '5216893';
            if (env.companyId !== account || String(env.currentPriceLevel) !== '5' ||
                    !env.currentCurrency || env.currentCurrency.code !== 'USD' ||
                    !env.currentLanguage || env.currentLanguage.locale !== 'en_US' ||
                    !env.siteSettings || String(env.siteSettings.siteid) !== '2' || !config ||
                    !Array.isArray(config.searchApiMasterOptions)) return null;
            var options = config.searchApiMasterOptions.filter(function(option) { return option.id === (details ? 'itemDetails' : 'Facets'); });
            if (options.length !== 1 || options[0].fieldset !== (details ? 'details' : 'search') || options[0].include !== 'facets' ||
                    Object.keys(options[0]).some(function(name) { return ['id', 'fieldset', 'include'].indexOf(name) < 0; })) return null;
            var buyFlu = win.location.hostname.indexOf('buyflu') === 0;
            var excluded = buyFlu ?
                'custitem_awa_domains,custitem_awa_pb_include_in_form,custitem_awa_customer_category,custitem_nms_featured_products' :
                'custitem_featured_products,custitem_most_popular_products,custitem_new_products,custitem_awa_domains,custitem_awa_customer_category,custitem_awa_pb_include_in_form,custitem_nms_featured_products,pricelevel5';
            var params = {c: account, country: 'US', currency: 'USD', 'facet.exclude': excluded,
                fieldset: details ? 'details' : 'search', include: 'facets', language: 'en', n: '2', pricelevel: '5', use_pcv: 'T'};
            if (details) params.url = current.slice(1);
            else {
                params.commercecategoryurl = current;
                params.custitem_awa_domains = win.location.hostname.replace('-sandbox.', '~sandbox.');
                params.limit = '24'; params.offset = '0'; params.sort = 'displayname:asc';
                params.matrixchilditems_fieldset = 'matrixchilditems_search';
            }
            var url = new win.URL('/api/cacheable/items', win.location.href);
            Object.keys(params).forEach(function(name) { url.searchParams.set(name, params[name]); });
            return {url: url.href, key: key(url.href)};
        }
        environment.done(function(environmentData) {
            var profile = environmentData && environmentData.ENVIRONMENT && environmentData.ENVIRONMENT.PROFILE ||
                win.SC.ENVIRONMENT.PROFILE;
            if (!profile || profile.isLoggedIn !== 'F' || profile.isRecognized !== 'F' ||
                    !doc.body || doc.readyState === 'complete') return;
            var current = route(), discoveryObserver, discoveryStopped = false;
            if (current === '/' || current.indexOf('/sca-dev-') === 0) return;
            function stopDiscovery() {
                discoveryStopped = true;
                if (discoveryObserver) discoveryObserver.disconnect();
                if (doc.removeEventListener) doc.removeEventListener('DOMContentLoaded', finishDiscovery);
            }
            function discoverPreload() {
                if (discoveryStopped) return true;
                if (route() !== current || doc.readyState === 'complete' ||
                        profile.isLoggedIn !== 'F' || profile.isRecognized !== 'F') {
                    stopDiscovery(); return true;
                }
                var candidates = [], seen = {};
            Array.prototype.forEach.call(doc.body.children, function(image) {
                if (image.tagName !== 'IMG' || image.style.display !== 'none') return;
                var normalized = key(image.src), url;
                if (!normalized || seen[normalized]) return;
                url = new win.URL(image.src, win.location.href);
                var params = url.searchParams, fieldset = params.get('fieldset');
                var unknown = false;
                params.forEach(function(value, name) {
                    if (['c', 'n', 'fieldset', 'commercecategoryurl', 'pricelevel', 'currency', 'country',
                        'language', 'use_pcv', 'offset', 'limit', 'sort', 'facet.exclude',
                        'matrixchilditems_fieldset', 'include', 'url', 'custitem_awa_domains'].indexOf(name) < 0) unknown = true;
                });
                if (unknown || params.has('pcv_groups') || params.has('pcv_all_items') || params.has('session') ||
                        params.get('pricelevel') !== '5' || params.get('use_pcv') !== 'T' ||
                        params.get('currency') !== 'USD' || params.get('country') !== 'US' ||
                        params.get('language') !== 'en' || params.get('n') !== '2' ||
                        !/^5216893(?:_SB1)?$/.test(params.get('c') || '')) return;
                if (!(fieldset === 'search' && params.get('commercecategoryurl') === current &&
                        params.get('offset') === '0' && params.get('limit') === '24' ||
                        fieldset === 'details' && params.get('url') === current.slice(1))) return;
                seen[normalized] = true; candidates.push({url: url.href, key: normalized});
            });
            if (!candidates.length) return false;
            stopDiscovery();
            if (candidates.length !== 1) return true;
            startRequest(candidates[0], current);
                return true;
            }
            function finishDiscovery() { discoverPreload(); stopDiscovery(); }
            if (discoverPreload()) return;
            var initial = initialCatalogRequest(current);
            if (initial) { stopDiscovery(); startRequest(initial, current); return; }
            // A cached/early user response can precede the parser's native item
            // preload images. Watch only those direct body children until parsing
            // ends; do not change guest eligibility or manufacture a query.
            if (doc.readyState === 'loading' && win.MutationObserver) {
                discoveryObserver = new win.MutationObserver(function(mutations) {
                    var relevant = mutations.some(function(mutation) {
                        if (mutation.type === 'attributes') return mutation.target.tagName === 'IMG' && mutation.target.parentNode === doc.body;
                        return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
                            return node.tagName === 'IMG' && node.parentNode === doc.body;
                        });
                    });
                    if (relevant) discoverPreload();
                });
                discoveryObserver.observe(doc.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'style']});
                doc.addEventListener('DOMContentLoaded', finishDiscovery, {once: true});
            }

        });
    }

    // Run after NetSuite's CMS script has installed its fetch implementation.
    // Only the server-qualified, ordinary public page may speculate; the native
    // CMS request must match its URL and fetch options before taking this result.
    function installEarlyCmsContent(win, doc, page) {
        if (win.nmsEarlyCmsContent || !win.fetch || !win.Headers || !win.URL || !win.AbortController ||
                !win.SC || !win.SC.ENVIRONMENT || win.SC.ENVIRONMENT.jsEnvironment !== 'browser' ||
                !win.SC.isPageGenerator || win.SC.isPageGenerator() || !page ||
                ['nmsincusa.com', 'buyflushots.nmsincusa.com', 'sca-sandbox.ethanablatt.com', 'buyflu-sandbox.ethanablatt.com'].indexOf(win.location.hostname) < 0) return;
        var types = {home: 'home-page', products: 'facet-browse', pdp: 'ProductDetails.Full.View'};
        var route = win.location.pathname, type = types[page.family], env = win.SC.ENVIRONMENT;
        if (!type || page.path !== route || win.location.search || win.location.hash ||
                page.family === 'home' && route !== '/' ||
                page.family === 'products' && route.indexOf('/products') !== 0 ||
                page.family === 'pdp' && !/^\/[A-Za-z0-9][A-Za-z0-9._-]*$/.test(route) ||
                !env.useCMS || !env.currentLanguage || env.currentLanguage.locale !== 'en_US' ||
                !win.SC.CONFIGURATION || !win.SC.CONFIGURATION.cms ||
                win.SC.CONFIGURATION.cms.useCMS !== true || win.SC.CONFIGURATION.cms.adapterVersion !== '3') return;
        var environment = win.loadedResourcesPromises && win.loadedResourcesPromises.shoppingUserEnvironment;
        if (!environment || typeof environment.done !== 'function') return;
        var nativeFetch = win.fetch, ready = null, used = false, active = true, state = 'idle', finished = 0;
        var stats = {started: 0, reused: 0, failed: 0, expired: 0};
        var url = '/api/cms/v2/contents?path=' + encodeURIComponent(route) + '&pagetype=' + type + '&locale=en_US';
        function sameRoute() { return active && win.location.pathname === route && !win.location.search && !win.location.hash; }
        function guest() {
            try {
                // After model hydration, the native environment may release PROFILE.
                // Use the actual model when available; never infer anonymity from absence.
                if (win.require) {
                    var model = win.require('Profile.Model').getInstance();
                    return model.get('isLoggedIn') === 'F' && model.get('isRecognized') === 'F';
                }
            } catch (notMounted) { /* The exact current-document environment owns the earlier phase. */ }
            var value = environment.status === 'resolved' && environment.data;
            var profile = win.SC.ENVIRONMENT.PROFILE || value && value.ENVIRONMENT && value.ENVIRONMENT.PROFILE;
            return !!(profile && profile.isLoggedIn === 'F' && profile.isRecognized === 'F');
        }
        function matches(input, init) {
            if (typeof input !== 'string' || !init || !sameRoute() || !guest()) return false;
            try {
                if (new win.URL(input, win.location.href).href !== new win.URL(url, win.location.href).href ||
                        Object.keys(init).some(function(k) { return ['credentials', 'headers', 'method'].indexOf(k) < 0; }) ||
                        (init.method || 'GET').toUpperCase() !== 'GET' || init.credentials !== 'include') return false;
                var headers = [];
                new win.Headers(init.headers || {}).forEach(function(value, name) { headers.push([name, value]); });
                return headers.length === 1 && headers[0][0] === 'content-type' &&
                    headers[0][1].toLowerCase() === 'application/json; charset=utf-8';
            } catch (error) { return false; }
        }
        function disable() { active = false; ready = null; }
        ['pointerdown', 'keydown', 'touchstart', 'pagehide'].forEach(function(name) {
            win.addEventListener(name, disable, {capture: true, once: true});
        });
        win.fetch = function(input, init) {
            if (used || !ready || state === 'failed' || !matches(input, init)) return nativeFetch.apply(this, arguments);
            if (state === 'ready' && Date.now() - finished > 10000) { disable(); stats.expired += 1; return nativeFetch.apply(this, arguments); }
            used = true; stats.reused += 1;
            var pending = ready, receiver = this, args = arguments; ready = null;
            return pending.then(function(response) {
                return response && sameRoute() && guest() ? response.clone() : nativeFetch.apply(receiver, args);
            });
        };
        win.nmsEarlyCmsContent = {getStatistics: function() { return {started: stats.started, reused: stats.reused, failed: stats.failed, expired: stats.expired}; }};
        environment.done(function(data) {
            var profile = data && data.ENVIRONMENT && data.ENVIRONMENT.PROFILE || win.SC.ENVIRONMENT.PROFILE;
            if (state !== 'idle' || !sameRoute() || !profile || profile.isLoggedIn !== 'F' || profile.isRecognized !== 'F') return;
            state = 'pending'; stats.started += 1;
            var controller = new win.AbortController();
            var timer = win.setTimeout(function() { controller.abort(); }, 8000);
            try {
                ready = nativeFetch.call(win, url, {credentials: 'include', headers: {'Content-type': 'application/json; charset=utf-8'}, signal: controller.signal}).then(function(response) {
                    if (!response || response.status !== 200 || !/application\/json/i.test(response.headers.get('Content-Type') || '')) throw new Error('Native CMS fallback required');
                    return response.clone().text().then(function(text) {
                        var body = text.length <= 500000 && JSON.parse(text);
                        if (!body || !Array.isArray(body.data) || body.error || body.errorCode) throw new Error('Native CMS fallback required');
                        state = 'ready'; finished = Date.now();
                        win.setTimeout(function() { if (!used && state === 'ready') { disable(); stats.expired += 1; } }, 10000);
                        return response;
                    });
                }).catch(function() { state = 'failed'; stats.failed += 1; return null; }).then(function(response) {
                    win.clearTimeout(timer); return response;
                });
            } catch (error) { win.clearTimeout(timer); state = 'failed'; stats.failed += 1; ready = null; }
        });
    }

    function anonymous() {
        var model = ProfileModel && ProfileModel.getInstance && ProfileModel.getInstance();
        return !!(model && model.get('isLoggedIn') === 'F' && model.get('isRecognized') === 'F');
    }

    function takePdpAvailability(win, expectedRoute, callback) {
        var bridge = win.nmsInitialItemData;
        if (!anonymous() || !bridge || typeof bridge.takeAvailability !== 'function') return false;
        return bridge.takeAvailability(expectedRoute, function(value) {
            // A sign-in or recognition change while waiting must use the native
            // current-session fallback instead of an anonymous prefetched status.
            callback(anonymous() ? value : null);
        });
    }

    function installDataTransport(win) {
        if (jQuery.nmsInitialItemTransport || !win.nmsInitialItemData) return;
        var bridge = win.nmsInitialItemData;
        jQuery.ajaxTransport('+json', function(options) {
            if (!anonymous() || options.type !== 'GET' || options.async === false || options.crossDomain ||
                    options.username || options.password || options.data ||
                    options.mimeType || !jQuery.ajaxSettings || options.xhr !== jQuery.ajaxSettings.xhr || options.xhrFields && Object.keys(options.xhrFields).length ||
                    !bridge.canTake(options.url)) return;
            var stopped = false, nativeXhr = null;
            return {
                send: function(headers, complete) {
                    var expected = bridge.expectedHeaders, mismatch = false;
                    Object.keys(headers).forEach(function(name) {
                        var known = Object.keys(expected).filter(function(k) { return k.toLowerCase() === name.toLowerCase(); })[0];
                        if (!known || String(headers[name]).toLowerCase() !== expected[known].toLowerCase()) mismatch = true;
                    });
                    function fallback() {
                        if (stopped) return;
                        nativeXhr = options.xhr(); nativeXhr.open(options.type, options.url, true);
                        if (!Object.keys(headers).some(function(name) { return name.toLowerCase() === 'x-requested-with'; })) {
                            nativeXhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                        }
                        Object.keys(headers).forEach(function(name) { nativeXhr.setRequestHeader(name, headers[name]); });
                        nativeXhr.onload = function() { if (!stopped) complete(nativeXhr.status, nativeXhr.statusText, {text: nativeXhr.responseText}, nativeXhr.getAllResponseHeaders()); };
                        nativeXhr.onerror = nativeXhr.ontimeout = function() { if (!stopped) complete(0, 'error'); };
                        nativeXhr.send();
                    }
                    if (mismatch || !anonymous() || !bridge.take(options.url, function(entry) {
                        if (stopped) return;
                        win.setTimeout(function() {
                            if (stopped) return;
                            if (!entry || entry.state !== 'ready' || !anonymous() || Date.now() - entry.finished > 10000) fallback();
                            else complete(200, entry.statusText || 'OK', {text: entry.text}, entry.headers);
                        }, 0);
                    })) fallback();
                },
                abort: function() { stopped = true; if (nativeXhr) nativeXhr.abort(); }
            };
        });
        jQuery.nmsInitialItemTransport = true;
    }

    function installHomeRequestSharing(win, doc) {
        if (win.nmsHomeFetchSharing || typeof win.fetch !== 'function' || !win.Headers) return;
        // Extensions mount before the native Profile model has always been populated.
        // Install the guard while that state is unknown; requestKey still requires
        // explicit anonymous flags for every request, including pending duplicates.
        var initialProfile = ProfileModel && ProfileModel.getInstance && ProfileModel.getInstance();
        if (initialProfile && (initialProfile.get('isLoggedIn') === 'T' ||
                initialProfile.get('isRecognized') === 'T')) return;
        var nativeFetch = win.fetch, pending = Object.create(null), active = true, shared = 0;
        function home() {
            var path = (win.location.hash && win.location.hash.replace(/^#\/?/, '/') || win.location.pathname).split('?')[0];
            return path === '/' || path === '';
        }
        if (!home()) return;
        win.setTimeout(function() { disable(); }, 15000);
        function homeAnonymous() {
            if (anonymous()) return true;
            var model = ProfileModel && ProfileModel.getInstance && ProfileModel.getInstance();
            var logged = model && model.get('isLoggedIn'), recognized = model && model.get('isRecognized');
            if (logged !== undefined && logged !== 'F' || recognized !== undefined && recognized !== 'F') return false;
            // The native, current-document user-environment response is authoritative
            // while Profile.Model is still hydrating. Never infer anonymity from absence.
            var environment = win.loadedResourcesPromises && win.loadedResourcesPromises.shoppingUserEnvironment;
            var data = environment && environment.status === 'resolved' && environment.data;
            var profile = data && data.ENVIRONMENT && data.ENVIRONMENT.PROFILE || data && data.PROFILE;
            return !!(profile && profile.isLoggedIn === 'F' && profile.isRecognized === 'F');
        }
        function requestKey(input, init) {
            if (!active || !home() || !homeAnonymous() || typeof input !== 'string' || init && (init.signal || init.body)) return null;
            try {
                var url = new win.URL(input, win.location.href), options = init || {}, method = (options.method || 'GET').toUpperCase();
                if (Object.keys(options).some(function(name) {
                    return ['method', 'headers', 'credentials', 'cache', 'mode', 'redirect', 'referrer', 'referrerPolicy', 'integrity'].indexOf(name) < 0;
                })) return null;
                if (url.origin !== win.location.origin || method !== 'GET' || url.hash) return null;
                var zone = url.pathname === '/api/cms/v2/merchzones/1' && url.searchParams.get('locale') === 'en_US';
                var items = url.pathname === '/api/items' && url.searchParams.get('fieldset') === 'search' &&
                    url.searchParams.get('custitem_featured_products') === 'true' && url.searchParams.get('limit') === '12';
                if (!zone && !items) return null;
                var headers = [], unsupported = false;
                new win.Headers(options.headers || {}).forEach(function(value, name) {
                    if (['accept', 'content-type', 'x-requested-with', 'x-sc-touchpoint'].indexOf(name) < 0) unsupported = true;
                    headers.push([name, value]);
                });
                if (unsupported) return null;
                headers.sort();
                return JSON.stringify([url.href, method, headers, options.credentials || 'same-origin',
                    options.cache || 'default', options.mode || '', options.redirect || '',
                    options.referrer || '', options.referrerPolicy || '', options.integrity || '']);
            } catch (error) { return null; }
        }
        function disable() { active = false; pending = Object.create(null); }
        ['pointerdown', 'keydown', 'touchstart'].forEach(function(name) { doc.addEventListener(name, disable, {capture: true, once: true}); });
        win.fetch = function(input, init) {
            var key = requestKey(input, init);
            if (!key) return nativeFetch.apply(this, arguments);
            if (!pending[key]) {
                pending[key] = nativeFetch.apply(this, arguments);
                var current = pending[key];
                current.then(function() { win.setTimeout(function() { if (pending[key] === current) delete pending[key]; }, 0); },
                    function() { if (pending[key] === current) delete pending[key]; });
            } else shared += 1;
            return pending[key].then(function(response) { return response.clone(); });
        };
        win.nmsHomeFetchSharing = {getStatistics: function() { return {shared: shared, active: active}; }};
    }

    return {
        installEarlyUserEnvironment: installEarlyUserEnvironment,
        installEarlyCatalogData: installEarlyCatalogData,
        installEarlyCmsContent: installEarlyCmsContent,
        takePdpAvailability: takePdpAvailability,
        installDataTransport: installDataTransport,
        installHomeRequestSharing: installHomeRequestSharing,
        mountToApp: function() {
            if (typeof window === 'undefined' || typeof SC === 'undefined' ||
                    !SC.ENVIRONMENT || SC.ENVIRONMENT.jsEnvironment !== 'browser' || SC.isPageGenerator()) return;
            installDataTransport(window);
            installHomeRequestSharing(window, document);
        }
    };
});
